import { render, staticRenderFns } from "./FlvPlayerRealTimeHegu.vue?vue&type=template&id=5becfab4&scoped=true"
import script from "./FlvPlayerRealTimeHegu.vue?vue&type=script&lang=js"
export * from "./FlvPlayerRealTimeHegu.vue?vue&type=script&lang=js"
import style0 from "./FlvPlayerRealTimeHegu.vue?vue&type=style&index=0&id=5becfab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becfab4",
  null
  
)

export default component.exports